/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.authFullApp'

export { $nsid }

const main = /*#__PURE__*/ l.permissionSet(
  $nsid,
  [
    /*#__PURE__*/ l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'app.bsky.actor.getPreferences',
        'app.bsky.actor.getProfile',
        'app.bsky.actor.getProfiles',
        'app.bsky.actor.getSuggestions',
        'app.bsky.actor.putPreferences',
        'app.bsky.actor.searchActors',
        'app.bsky.actor.searchActorsTypeahead',
        'app.bsky.bookmark.createBookmark',
        'app.bsky.bookmark.deleteBookmark',
        'app.bsky.bookmark.getBookmarks',
        'app.bsky.contact.dismissMatch',
        'app.bsky.contact.getMatches',
        'app.bsky.contact.getSyncStatus',
        'app.bsky.contact.importContacts',
        'app.bsky.contact.removeData',
        'app.bsky.contact.startPhoneVerification',
        'app.bsky.contact.verifyPhone',
        'app.bsky.feed.describeFeedGenerator',
        'app.bsky.feed.getActorFeeds',
        'app.bsky.feed.getActorLikes',
        'app.bsky.feed.getAuthorFeed',
        'app.bsky.feed.getFeed',
        'app.bsky.feed.getFeedGenerator',
        'app.bsky.feed.getFeedGenerators',
        'app.bsky.feed.getFeedSkeleton',
        'app.bsky.feed.getLikes',
        'app.bsky.feed.getListFeed',
        'app.bsky.feed.getPostThread',
        'app.bsky.feed.getPosts',
        'app.bsky.feed.getQuotes',
        'app.bsky.feed.getRepostedBy',
        'app.bsky.feed.getSuggestedFeeds',
        'app.bsky.feed.getTimeline',
        'app.bsky.feed.searchPosts',
        'app.bsky.feed.sendInteractions',
        'app.bsky.graph.getActorStarterPacks',
        'app.bsky.graph.getBlocks',
        'app.bsky.graph.getFollowers',
        'app.bsky.graph.getFollows',
        'app.bsky.graph.getKnownFollowers',
        'app.bsky.graph.getList',
        'app.bsky.graph.getListBlocks',
        'app.bsky.graph.getListMutes',
        'app.bsky.graph.getLists',
        'app.bsky.graph.getListsWithMembership',
        'app.bsky.graph.getMutes',
        'app.bsky.graph.getRelationships',
        'app.bsky.graph.getStarterPack',
        'app.bsky.graph.getStarterPacks',
        'app.bsky.graph.getStarterPacksWithMembership',
        'app.bsky.graph.getSuggestedFollowsByActor',
        'app.bsky.graph.muteActor',
        'app.bsky.graph.muteActorList',
        'app.bsky.graph.muteThread',
        'app.bsky.graph.searchStarterPacks',
        'app.bsky.graph.unmuteActor',
        'app.bsky.graph.unmuteActorList',
        'app.bsky.graph.unmuteThread',
        'app.bsky.labeler.getServices',
        'app.bsky.notification.getPreferences',
        'app.bsky.notification.getUnreadCount',
        'app.bsky.notification.listActivitySubscriptions',
        'app.bsky.notification.listNotifications',
        'app.bsky.notification.putActivitySubscription',
        'app.bsky.notification.putPreferences',
        'app.bsky.notification.putPreferencesV2',
        'app.bsky.notification.registerPush',
        'app.bsky.notification.unregisterPush',
        'app.bsky.notification.updateSeen',
        'app.bsky.unspecced.getAgeAssuranceState',
        'app.bsky.unspecced.getConfig',
        'app.bsky.unspecced.getOnboardingSuggestedStarterPacks',
        'app.bsky.unspecced.getPopularFeedGenerators',
        'app.bsky.unspecced.getPostThreadOtherV2',
        'app.bsky.unspecced.getPostThreadV2',
        'app.bsky.unspecced.getSuggestedFeeds',
        'app.bsky.unspecced.getSuggestedFeedsSkeleton',
        'app.bsky.unspecced.getSuggestedStarterPacks',
        'app.bsky.unspecced.getSuggestedStarterPacksSkeleton',
        'app.bsky.unspecced.getSuggestedUsers',
        'app.bsky.unspecced.getSuggestedUsersSkeleton',
        'app.bsky.unspecced.getSuggestionsSkeleton',
        'app.bsky.unspecced.getTaggedSuggestions',
        'app.bsky.unspecced.getTrendingTopics',
        'app.bsky.unspecced.getTrends',
        'app.bsky.unspecced.getTrendsSkeleton',
        'app.bsky.unspecced.initAgeAssurance',
        'app.bsky.unspecced.searchActorsSkeleton',
        'app.bsky.unspecced.searchPostsSkeleton',
        'app.bsky.unspecced.searchStarterPacksSkeleton',
        'app.bsky.video.getJobStatus',
        'app.bsky.video.getUploadLimits',
        'app.bsky.video.uploadVideo',
      ],
    }),
    /*#__PURE__*/ l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: [
        'app.bsky.actor.profile',
        'app.bsky.actor.status',
        'app.bsky.feed.like',
        'app.bsky.feed.post',
        'app.bsky.feed.postgate',
        'app.bsky.feed.repost',
        'app.bsky.feed.threadgate',
        'app.bsky.graph.block',
        'app.bsky.graph.follow',
        'app.bsky.graph.list',
        'app.bsky.graph.listblock',
        'app.bsky.graph.listitem',
        'app.bsky.graph.starterpack',
        'app.bsky.notification.declaration',
      ],
    }),
  ],
  {
    title: 'Full Bluesky Social App Permissions',
    'title:lang': {},
    detail:
      'Manage all public content and interactions, private preferences and subscriptions, and other Bluesky-specific app features and data.',
    'detail:lang': {},
  },
)

export { main }
